import {
  ControlWithDescription,
  InlineWithDescription,
} from 'components/form-layouts';

import { RffInput } from '@cast/shared-rff-ui';

import { Typography, tokens } from '@cast/design-system';

export const StorageSection = () => {
  return (
    <>
      <Typography
        variant="L14M"
        color={tokens.theme.fg.structural.secondary}
        sx={{ mt: 22 }}
      >
        Edge configuration overrides
      </Typography>

      <InlineWithDescription
        borderBottom="none"
        description={
          <ControlWithDescription label="Storage">
            Set the boot disk size for the node. Leave blank to inherit from the
            linked edge configuration.
          </ControlWithDescription>
        }
        controls={
          <RffInput
            name="bootDiskGib"
            label="Boot disk size"
            type="number"
            min={1}
            placeholder="e.g. 100"
            endAdornment="GiB"
            testId="boot-disk-size-input"
          />
        }
      />
    </>
  );
};
